import { useFetchBillingData } from "@sushicorp/services";
import React, { useState } from "react";

import Styles from "./BillingDataModal.styles";
import { BillingDataModalProps as Props } from "./BillingDataModal.types";
import AddNewRecordButton from "components/global/AddNewRecordButton/AddNewRecordButton";
import Modal from "components/global/Modal/Modal";
import SearchBillingData from "components/global/SearchBillingData/SearchBillingData";
import BillingDataList from "components/profile/BillingDataList/BillingDataList";
import { ModalHeaderStyled } from "components/profile/BillingDataPreview/BillingDataPreview.styles";
import BillingFormModal from "components/profileBilling/BillingFormModal/BillingFormModal";
import CONSTANTS from "config/constants";
import useAuth from "contexts/auth/auth.context.hooks";
import useI18n from "hooks/useI18n";
import { notify } from "utils/common.utils";
import { dismissErrorNotification } from "utils/notifications.utils";
import { createErrorNotification } from "utils/notifications.utils";

import CloseSVG from "../../../../public/assets/images/close.svg";

const { MAX_NUMBER_OF_BILLING_DATA } = CONSTANTS.CONSTRAINTS;

const BillingDataModal: React.FC<Props> = props => {
  const t = useI18n();
  const { onClose, showSearch = false, moreActions = [] } = props;
  const [step, setStep] = useState(1);
  const auth = useAuth();
  const fetchBillingData = useFetchBillingData(auth, notify);
  const { data: billingDataList } = fetchBillingData;
  const { isLoading, isError } = fetchBillingData;
  const [searchResult, setSearchResult] = useState("");

  const closeHandler = () => {
    setStep(1);
    onClose?.();
  };

  const validateNumberBilling = () => {
    if ((billingDataList?.length ?? 0) >= MAX_NUMBER_OF_BILLING_DATA) {
      dismissErrorNotification();
      const maxBillingError = t.errors.maxBillingLimit(
        MAX_NUMBER_OF_BILLING_DATA
      );
      createErrorNotification(maxBillingError, t.errors.overBillingLimit);
      return null;
    }
    setStep(2);
  };

  const modalHeaderNode = (
    <ModalHeaderStyled>
      <p className="ModalHeaderStyled__header">
        {t.billing.newBillingInformation}
      </p>
    </ModalHeaderStyled>
  );

  if (step === 2)
    return (
      <BillingFormModal
        {...props}
        onClose={closeHandler}
        header={modalHeaderNode}
        closeIcon={<CloseSVG />}
      />
    );

  return (
    <Modal {...props} closeIcon={<CloseSVG />}>
      <Styles className="BillingDataModal">
        <header className="BillingDataModal__header">
          <p className="BillingDataModal__title">
            {t.billing.billingInformation}
          </p>
        </header>
        <div className="BillingDataModal__wrapper">
          {showSearch ? (
            <SearchBillingData
              setSearchResult={setSearchResult}
              isDisabled={isLoading}
            />
          ) : null}
          <AddNewRecordButton
            onClick={validateNumberBilling}
            value={t.billing.addBillingInformation}
            mobileValue={t.common.add}
          />
          <BillingDataList
            className="BillingDataModal__list"
            actions={["edit", "delete", ...moreActions]}
            searchResult={searchResult}
            billingDataList={billingDataList}
            isLoading={isLoading}
            isError={isError}
          />
        </div>
      </Styles>
    </Modal>
  );
};

BillingDataModal.defaultProps = {};

export default BillingDataModal;
